<template>
  <div class="empty-state" :style="{ minHeight: `${height}px` }">
    <span class="empty-state-title">{{ title }}</span>
    <p class="empty-state-message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "GcDashboardEmptyState",
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    height: {
      type: [Number, String],
      default: 200,
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px 16px;
}

.empty-state-title {
  font-weight: bold;
  font-size: 22px;
  color: #666;
}

.empty-state-message {
  margin: 8px 0 0;
  color: #999;
  font-size: 13px;
  max-width: 420px;
}
</style>
